module.exports = __webpack_public_path__ + "static/media/img-grow-screen@3x.4e9de2d0.png";